import {UserEvent} from './UserEvent';

export class UserCreated extends UserEvent {}
